export default function ContentBody({ data }) {
  if (!data) return null;

  return (
    <>
      {data.content && (
        <div dangerouslySetInnerHTML={{ __html: data.content }} />
      )}
      {(data.paragraphs || []).map((p, i) => {
        if (p.type === "quote-left" || p.type === "quote-right") {
          return (
            <blockquote key={i} className={`content-quote content-${p.type}`}>
              <div dangerouslySetInnerHTML={{ __html: p.body }} />
              {p.heading && <cite>{p.heading}</cite>}
            </blockquote>
          );
        }
        const Heading = p.headingLevel || "h2";
        return (
          <section key={i} style={{ overflow: "hidden" }}>
            {p.heading && <Heading>{p.heading}</Heading>}
            {p.body && <div dangerouslySetInnerHTML={{ __html: p.body }} />}
          </section>
        );
      })}
    </>
  );
}
